import api from '@Services/api';
import { CourseIdentity, SubmissionEndpoints } from './Submissions.types';

/**
 * The grading actions exist twice on the backend — once per content parent —
 * and the only payload difference is `standalone_lecture_id`, which the
 * standalone-lecture routes' contentParent middleware requires (422 without
 * it, 403 on a mismatch). Both apps' api instances carry their own portal
 * prefix, so the relative paths below resolve to the admin or the instructor
 * routes automatically.
 */
export function endpointsForCourse(course: CourseIdentity): SubmissionEndpoints {
	// A course without a classroom is a standalone lecture. Every list preloads
	// both parent ids now; a row carrying neither can only have come from a
	// standalone queue, which is why the absence of a classroom is the test.
	const standalone = !course.classroom_id;
	if (standalone) {
		const standalone_lecture_id = course.id;
		return {
			gradeQuestion: (payload) =>
				api.post('standalone-courses/lectures/test/questions/grade', {
					...payload,
					standalone_lecture_id,
				}),
			closeAttempt: (attempt_id) =>
				api.post('standalone-courses/lectures/test/submit', {
					attempt_id,
					standalone_lecture_id,
				}),
			bulkGrade: (attempt_id, verdict) =>
				api.post('standalone-courses/lectures/test/submit/all', {
					attempt_id,
					verdict,
					standalone_lecture_id,
				}),
			scoreAssignment: (payload) =>
				api.post('standalone-courses/lectures/assignment/submission/score', {
					...payload,
					standalone_lecture_id,
				}),
		};
	}
	return {
		gradeQuestion: (payload) => api.post('test/questions/grade', payload),
		closeAttempt: (attempt_id) => api.post('test/submit', { attempt_id }),
		bulkGrade: (attempt_id, verdict) =>
			api.post('test/submit/all', { attempt_id, verdict }),
		scoreAssignment: (payload) => api.post('assignment/submission/score', payload),
	};
}
